/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const ProfileCircled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Profile circled"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M12 6.167a4.167 4.167 0 0 1 2.5 7.5A4.16 4.16 0 0 1 16.166 17H14.5a2.5 2.5 0 0 0-5 0H7.833A4.16 4.16 0 0 1 9.5 13.667a4.167 4.167 0 0 1 2.5-7.5m0 1.666a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
        clipRule="evenodd"
      />
      <path
        fill="#0E0E0E"
        d="M20.333 12A8.333 8.333 0 1 0 12 20.333V22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10v-1.667A8.333 8.333 0 0 0 20.333 12"
      />
    </g>
  </svg>
);

export const ProfileCircledIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'profile-circled-icon'}
      icon={ProfileCircled}
      {...props}
      size={size}
    />
  );
};
